import type { ReportComment } from 'state/report/types'

export const normalizeCommentText = (comment: ReportComment) => ({
  ...comment,
  text: comment.text || '',
})
